import type { Icon } from '@onefootprint/icons';
import { IcoInfo16 } from '@onefootprint/icons';

import Tooltip from '../tooltip';

export type LabelTooltipProps = {
  text: string;
  triggerAriaLabel?: string;
  iconComponent?: Icon;
};

export type LabelProps = {
  children: string;
  hasError?: boolean;
  htmlFor?: string;
  id?: string;
  size?: 'default' | 'compact';
  tooltip?: LabelTooltipProps;
};

const Label = ({ children, hasError = false, htmlFor, id, size = 'default', tooltip = undefined }: LabelProps) => (
  <div className="mb-2 flex flex-row justify-start gap-1">
    <label
      /** Do not change/remove these classes */
      className="fp-label fp-custom-appearance"
      data-has-error={hasError}
      data-size={size}
      htmlFor={htmlFor}
      id={id}
    >
      {children}
    </label>
    {tooltip && (
      <Tooltip disabled={!tooltip.text} content={tooltip.text}>
        <button
          type="button"
          aria-label={tooltip?.triggerAriaLabel ?? tooltip?.text}
          className="bg-none border-none m-0 pt-0.5 px-0 pb-0"
        >
          {tooltip?.iconComponent ? <tooltip.iconComponent /> : <IcoInfo16 />}
        </button>
      </Tooltip>
    )}
  </div>
);

export default Label;
